import React from 'react';
import {
    Description as DescriptionFallbackIcon,
    LocalFireDepartment as LocalFireDepartmentIcon,
    DirectionsCar as DirectionsCarIcon,
    Water as WaterIcon,
    Warning as WarningIcon,
    Build as BuildIcon,
    MedicalServices as MedicalServicesIcon,
    ElectricalServices as ElectricalServicesIcon,
    Flood as FloodIcon,
    Air as AirIcon,
    Pets as PetsIcon,
    Forest as ForestIcon,
    Home as HomeIcon,
    Business as BusinessIcon,
    Terrain as TerrainIcon,
    Tsunami as TsunamiIcon,
    Construction as ConstructionIcon,
    LocalShipping as LocalShippingIcon,
    GasMeter as GasMeterIcon,
    ElectricBolt as ElectricBoltIcon,
    Factory as FactoryIcon,
    Storm as StormIcon,
} from '@mui/icons-material';
import type { CreateSablonaRequest } from '../api/JsdhNotifikaceService/generated';

export const COLOR_PALETTE = [
    "#C62828", "#D32F2F", "#E53935", "#FF5252",
    "#AD1457", "#C2185B", "#E91E63", "#FF4081",
    "#6A1B9A", "#7B1FA2", "#9C27B0", "#CE93D8",
    "#4527A0", "#512DA8", "#673AB7", "#7C4DFF",
    "#1565C0", "#1976D2", "#2196F3", "#448AFF",
    "#00838F", "#0097A7", "#00BCD4", "#00E5FF",
    "#2E7D32", "#388E3C", "#4CAF50", "#69F0AE",
    "#558B2F", "#689F38", "#8BC34A", "#CCFF90",
    "#F57F17", "#F9A825", "#FDD835", "#FFFF00",
    "#FF6F00", "#FF8F00", "#FFA000", "#FFD740",
    "#E65100", "#EF6C00", "#FF5722", "#FF9100",
    "#4E342E", "#5D4037", "#795548", "#A1887F",
    "#263238", "#37474F", "#455A64", "#607D8B",
    "#212121", "#424242", "#616161", "#9E9E9E",
];

export const ICON_OPTIONS = [
    { key: 'local_fire_department', label: 'Požár' },
    { key: 'directions_car', label: 'Dopravní nehoda' },
    { key: 'water', label: 'Voda' },
    { key: 'storm', label: 'Bouře' },
    { key: 'medical_services', label: 'Zdravotní' },
    { key: 'warning', label: 'Varování' },
    { key: 'construction', label: 'Technická' },
    { key: 'forest', label: 'Les' },
    { key: 'home', label: 'Budova' },
    { key: 'flood', label: 'Záplava' },
    { key: 'factory', label: 'Průmysl' },
    { key: 'pets', label: 'Zvíře' },
    { key: 'electric_bolt', label: 'Elektřina' },
    { key: 'gas_meter', label: 'Plyn' },
    { key: 'terrain', label: 'Terén' },
    { key: 'local_shipping', label: 'Přeprava' },
];

export const TEMPLATE_ICON_COMPONENTS: Record<string, React.ElementType> = {
    'local_fire_department': LocalFireDepartmentIcon,
    'directions_car': DirectionsCarIcon,
    'water': WaterIcon,
    'storm': StormIcon,
    'medical_services': MedicalServicesIcon,
    'warning': WarningIcon,
    'construction': ConstructionIcon,
    'forest': ForestIcon,
    'home': HomeIcon,
    'flood': FloodIcon,
    'factory': FactoryIcon,
    'pets': PetsIcon,
    'electric_bolt': ElectricBoltIcon,
    'gas_meter': GasMeterIcon,
    'terrain': TerrainIcon,
    'local_shipping': LocalShippingIcon,
    // Legacy keys (for existing data in DB)
    'fire': LocalFireDepartmentIcon,
    'car-emergency': DirectionsCarIcon,
    'alert-circle': WarningIcon,
    'wrench': BuildIcon,
    'medical-bag': MedicalServicesIcon,
    'lightning-bolt': ElectricalServicesIcon,
    'weather-hurricane': TsunamiIcon,
    'weather-windy': AirIcon,
    'paw': PetsIcon,
    'tree': ForestIcon,
    'office-building': BusinessIcon,
    'waves': FloodIcon,
    'clipboard-text-outline': DescriptionFallbackIcon,
};

export const getTemplateIcon = (ikona?: string, size: number = 40): React.ReactElement => {
    const IconComp = ikona ? TEMPLATE_ICON_COMPONENTS[ikona] : undefined;
    if (IconComp) return <IconComp sx={{ fontSize: size }} />;
    return <DescriptionFallbackIcon sx={{ fontSize: size }} />;
};

export const emptyForm: CreateSablonaRequest = {
    nazev: '',
    ikona: '',
    barva: '#FF5722',
    poradi: 0,
    typId: undefined,
    podtypId: undefined,
    udalost: '',
    popis: '',
    obec: '',
    kraj: '',
    castObce: '',
    ulice: '',
    cisloPopisne: '',
    gps: '',
    objekt: '',
    upresneni: '',
    zobrazitMapu: false,
    mapaGps: '',
    mapaOkruh: 5,
    technikaIds: [],
    technikaJednotky: [],
    odeslatNotifikace: true,
    generovatTts: true,
    rychleVyhlaseni: false,
    predpoplach: false,
    kritickaNotifikace: false,
    userVyhlaseni: false,
};
